import apiClient from './api';

export interface DokumentationDatei {
  pfad: string;
  name: string;
  groesse: number;
}

function normalizeDatei(raw: any): DokumentationDatei {
  return {
    pfad: raw.pfad || raw.path || raw.filePath || '',
    name: raw.name || raw.fileName || '',
    groesse: raw.groesse || raw.size || raw.fileSize || 0
  };
}

export class DokumentationService {
  private static readonly BASE_URL = '/admin/documentation';

  static async getDateiListe(): Promise<DokumentationDatei[]> {
    const response = await apiClient.get(this.BASE_URL);
    console.log('Documentation API raw response:', JSON.stringify(response.data, null, 2));
    const raw = Array.isArray(response.data) ? response.data : [];
    return raw.map(normalizeDatei);
  }

  static async getDateiInhalt(filePath: string): Promise<string> {
    const response = await apiClient.get(`${this.BASE_URL}/${filePath}`, {
      transformResponse: [(data: string) => data],
      headers: { 'Accept': 'text/plain' }
    });
    return response.data;
  }
}
